import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=dea6fcca&scoped=true"
import script from "./Merchant.vue?vue&type=script&lang=js"
export * from "./Merchant.vue?vue&type=script&lang=js"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=dea6fcca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea6fcca",
  null
  
)

export default component.exports